import React from "react";
import { Route, Routes } from "react-router-dom";

import AdminDashboard from "./pages/AdminDashboard";
import ViewContent from "../ViewContent";
import AddSubChapter from "./pages/AddSubChapter";
import AddChapter from "./pages/AddChapter";
import AddImage from "./pages/AddImage";
import Order from "./pages/Order";
import Setting from "./pages/Setting";
import SideBar from "./SideBar";
import UpdateSubChapter from "./pages/UpdateSubChapter";
import UpdateChapter from "./pages/UpdateChapter";
import DeleteChapter from "./pages/DeleteChapter";
import DeleteSubChapter from "./pages/DeleteSubChapter";
import DeleteImg from "./pages/DeleteImg";
import UpdateImage from "./pages/UpdateImage";
import GetAllChapters from "../GetAllChapters";
import "../../css/Admin.css";
import Fonts from "./pages/Fonts";
import Subscription from "./pages/Subscription";
import AdminUploadImage from "./AdminUploadImage";
import ViewPackageList from "./pages/ViewPackageList";
import AddPackage from "./pages/AddPackage";
import EditPackage from "./pages/EditPackage";
import SubscriptionDetails from "./pages/SubscriptionDetails";
import ActivityTracker from "./pages/ActivityTracker";
import CoinManager from "./pages/CoinManager";

import GetAllTickets from "./pages/GetAllTickets";

import AdminAddBlog from "../Blog/AdminAddBlog";
import AdminBlogManager from "../Blog/AdminBlogManager";
import AdminDeleteBlog from "../Blog/AdminDeleteBlog";
import AdminEditBlog from "../Blog/AdminEditBlog";
import AdminGetBlog from "../Blog/AdminGetBlogs";
import AdminResearch from "../Blog/AdminResearch"
import AdminUpdateStatus from "../Blog/AdminUpdateStatus";
import BlogDashboard from "../Blog/BlogDashboard";
import BlogSection from "../Blog/BlogSection";
import CustomerAddBlog from "../Blog/CustomerAddBlog";
import CustomerDashboard from "../Blog/CustomerDashboard";
import Research from "../Blog/Research";


import GetAllCustomers from "../customer/pages/GetAllCustomers";
import Admindelete from "./pages/Admindelete";
import CustomerGetImg from "../customer/CustomerGetImg";
import EditHotspotImage from "../customer/pages/EditHotspotImage";
import UpdateHotspotImg from "./UpdateHotspotImg";
import AdminRoleBlogs from "../Blog/AdminRoleBlogs";
import EditBlog from "../Blog/EditBlog";
import AdminRoleResearch from "../Blog/AdminRoleResearch";
import RepertoryManagement from "./pages/RepertoryManagement";
import AllResearchPapers from "../Blog/AllResearchPapers";
import ResearchDetails from "../Blog/ResearchDetails";
import AdminResearchPapers from "../Blog/AdminResearchPapers";
import AdminResearchEditor from "../Blog/AdminResearchEditor";

function Admin() {
  return (
    <SideBar>
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/addchapter" element={<AddChapter />} />
        <Route path="/viewContent/:chapterNumber" element={<ViewContent />} />
        <Route path="/getallchapters" element={<GetAllChapters />} />
        <Route path="/getallcustomers" element={<GetAllCustomers />} />
        <Route path="/addsubchapter" element={<AddSubChapter />} />
        <Route path="/addimage" element={<AddImage />} />
        <Route path="/loadjson" element={<RepertoryManagement defaultTab="upload" />} />
        <Route path="/customergetimg" element={<CustomerGetImg/>}/>
        <Route path="/hotspotimg" element={<AdminUploadImage/>}/>
        <Route path="/updateimage" element={<UpdateImage />} />
        <Route path="/updatesubchapter" element={<UpdateSubChapter />} />
        <Route path="/updatechapter" element={<UpdateChapter />} />
            <Route path="/admindlt" element={<Admindelete/>}/>
          <Route
  path="/edit-hotspots/:chapterNumber/:subchapterNumber/:imageNumber"
  element={<EditHotspotImage />}
/>

        <Route path="/updatechapter/:chapterNum" element={<UpdateChapter />} />
        <Route path="/deletechapter" element={<DeleteChapter />} />
        <Route path="/deletesubchapter" element={<DeleteSubChapter />} />
        <Route path="/deleteimage" element={<DeleteImg />} />
        <Route path="/tickets" element={<GetAllTickets />} />
        <Route path="/order" element={<Order />} />
        <Route path="/settings" element={<Setting />} />
        <Route path="/fonts" element={<Fonts />} />
        <Route path="/subscriptions" element={<Subscription />} />
        <Route path="/subscriptiondetails" element={<SubscriptionDetails />} />
        <Route path="/packagelist" element={<ViewPackageList />} />
        <Route path="/addpackage" element={<AddPackage />} />
        <Route path="/editpackage/:packageId" element={<EditPackage />} />
        <Route path="/activitytracker" element={<ActivityTracker />} />
        <Route path="/coinmanager" element={<CoinManager />} />
        <Route path="/updatehotspotimg" element={<UpdateHotspotImg/>}/>
        <Route path="*" element={<div>404 - Page not found</div>} />

            {/* //blogs */}
        <Route path="/adminrepertorysearch" element={<RepertoryManagement defaultTab="search" />}/>
        <Route path="/repertory" element={<RepertoryManagement defaultTab="lessons" />}/>
        <Route path="/adminaddblog" element={<AdminAddBlog/>}/>
        <Route path="/adminblogmanager" element={<AdminBlogManager/>}/>
        <Route path="/admindltblog" element={<AdminDeleteBlog/>}/>
        <Route path="/admineditblog" element={<AdminEditBlog/>}/>
        <Route path="/admingetblogs" element={<AdminGetBlog/>}/>
        <Route path="/adminresearch" element={<AdminResearch/>}/>
        <Route path="/adminupdatestatus" element={<AdminUpdateStatus/>}/>
        <Route path="/adminroleblogs" element={<AdminRoleBlogs/>}/>
       <Route path="/edit-blog/:id" element={<EditBlog />} />
       <Route path="/adminroleresearch" element={<AdminRoleResearch/>}/>
       <Route path="/research" element={<AllResearchPapers/>}/>
       <Route path="/research/:id" element={<ResearchDetails/>}/>
       <Route path='/updatestsarticle' element={<AdminResearchPapers/>}/>
       <Route
  path="/researchadmin/edit/:id"
  element={<AdminResearchEditor/>}
/>

      </Routes>
    </SideBar>
  );
}

export default Admin;
